import { useContext, useEffect, useState } from "react";
import { IAdjudicationPendingFilter } from "../../Store/Adjudication/types"
import GridContainer from "./Components/grid/GridContainer";
import { BoxButton } from "./Components/BoxButton";
import ButtonLightGray from "./Components/ButtonLightGray";
import ChipFactory from "./Components/chips/ChipFactory";
import { GridButton } from "./Components/grid/GridButton";
import AdjudicationPendingDrawerMoreFilter from "./Components/drawer/AdjudicationPendingDrawerMoreFilter";
import ClearDbButton from "./Components/ClearDbButton";
import ConfirmationDialog from "../Misc/Dialog/ConfirmationDialog";
import { APIsContext } from "../../Store/APIs/context";
import { useSnackbar } from "notistack";
import Authentication from "../../Store/Authentication/AuthenticationStore";

interface IAdjudicationPendingFilterProps {
    onFilterApply: (filter: IAdjudicationPendingFilter) => void
    filter: IAdjudicationPendingFilter
}

const AdjudicationPendingFilter: React.FC<IAdjudicationPendingFilterProps> = (props) => {

    const apiState = useContext(APIsContext).state
    const [openMoreFilters, setOpenMoreFilters] = useState<boolean>(false)
    const [adjudicationPendingFilter, setAdjudicationPendingFilter] = useState<IAdjudicationPendingFilter>(props.filter)
    const [clearDbOpen, setClearDbOpen] = useState(false)
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        setAdjudicationPendingFilter(props.filter)
    }, [props.filter]);

    const setFilterChip = (filter: IAdjudicationPendingFilter) => {
        props.onFilterApply(filter)
        setAdjudicationPendingFilter(filter)
    }

    const resetFilter = () => {
        setAdjudicationPendingFilter({})
        props.onFilterApply({})
    }

    const onFilterApply = (filter: IAdjudicationPendingFilter) => {
        setAdjudicationPendingFilter(filter)
        props.onFilterApply(filter);
        setOpenMoreFilters(false)
    }

    const handleDbClear = () => {
        apiState.AdjudicationApi.clearAdjudicationsPendingDb().then(res => {
            enqueueSnackbar("Cleared pending adjudication cases", {variant: "info"})
            resetFilter()
        }).catch(e => {
            if (e.message) {
                enqueueSnackbar(e.message, {variant: "error"})
            } else {
                enqueueSnackbar("Failed to clear pending adjudication cases database", {variant: "error"})
            }
        })
    }

    return (
        <>
        <GridContainer container style={{paddingTop: 0}}>
            <GridButton item xs={6}>
                <ChipFactory
                    filter={props.filter}
                    setChip={setFilterChip}
                    clearFilter={resetFilter}
                    style={{paddingTop: 0}}
                />
            </GridButton>
            <GridButton item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                {Authentication.isAdminAuthenticated() && (
                    <ClearDbButton
                        onClick={() => setClearDbOpen(true)}
                        color="error"
                        variant="contained"
                    >
                        Clear pending cases
                    </ClearDbButton>
                )}
                <BoxButton>
                    <ButtonLightGray
                        onClick={() => setOpenMoreFilters(true)}
                        variant='text'
                        color="primary"
                        style={{height: "100%"}}
                    >
                        More filters
                    </ButtonLightGray>
                </BoxButton>
            </GridButton>
        </GridContainer>
        <AdjudicationPendingDrawerMoreFilter
            anchor='right'
            filter={adjudicationPendingFilter}
            setFilter={setAdjudicationPendingFilter}
            open={openMoreFilters}
            onClose={() => setOpenMoreFilters(false)}
            resetFilter={resetFilter}
            onFilterApply={onFilterApply}
        />
        <ConfirmationDialog
            open={clearDbOpen}
            setOpen={setClearDbOpen}
            title="Clear pending cases"
            cancelText="Cancel"
            confirmText="Yes, clear pending cases"
            confirm={handleDbClear}
            confirmColor="error"
            text="This action will clear all data in the pending adjudication cases log"
        />
        </>
    )
}

export default AdjudicationPendingFilter